module.exports = __webpack_public_path__ + "static/media/am.e3779687.jpeg";